import request from '@/utils/request'


export function uploadFile(formdata) {
    return request({
        url: 'api/v1/uploadFile',
        method: 'post',
        data: formdata,
        config: {
            headers: { 'Content-Type': 'multipart/form-data' }
        }
    })
}

//更新公司信息
export function updateCompany(data) {
    return request({
        url: 'api/v1/company/updateCompany',
        method: 'post',
        data
    })
}
